import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'
import { routing } from '@utils/routing'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import setUpACustomDomain from '../assets/set-up-a-custom-domain.png'

export const useCustomDomainRecommendation = () => {
  const { currentShop, isLoading: isLoadingCurrentShop } = useCurrentShop()
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()

  return {
    customDomainRecommendation: {
      id: 'customDomain',
      enabled:
        !!currentShop?.primaryDomain.endsWith('fourthwall.com') &&
        recommendationsDismiss.domain.visible,
      isLoading: isLoadingCurrentShop,
      suggestion: (
        <Suggestion
          title="Set up a custom domain"
          description="Give your site a custom domain (ex: creatorname.com)."
          imageUrl={setUpACustomDomain}
          buttonLabel="Connect a new domain"
          buttonTo={routing.settings.domain.self}
          analytics="setupACustomDomain"
          onDismiss={createOnDismiss(recommendationsDismiss.domain.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
